import { useEffect, useState } from 'react';
import { api, type DbAuditRow } from '../api';
import { Page, Card, EmptyState } from '../ui';

export function DbAudit() {
  const [rows, setRows] = useState<DbAuditRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState<string | null>(null);

  function reload() {
    api.getDbAudit(200).then(({ audit }) => setRows(audit)).catch(() => setErr('Falha ao carregar')).finally(() => setLoading(false));
  }
  useEffect(() => {
    reload();
    const t = setInterval(reload, 15000);
    return () => clearInterval(t);
  }, []);

  return (
    <Page title="Auditoria de banco" subtitle="Todo acesso a banco pedido por agentes (permitido ou negado), via o broker seguro.">
      {err && <div className="chat-error">{err}</div>}
      {loading ? (
        <div className="center">Carregando…</div>
      ) : rows.length === 0 ? (
        <EmptyState title="Sem registros" description="Nenhum acesso a banco por agente ainda." />
      ) : (
        <Card style={{ overflowX: 'auto' }}>
          <table className="dbaudit-table">
            <thead>
              <tr><th>quando</th><th>agente</th><th>ambiente</th><th>op</th><th>tabelas</th><th>SQL</th><th>resultado</th></tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id}>
                  <td>{new Date(r.createdAt).toLocaleString()}</td>
                  <td>{r.agentSlug ?? '—'}</td>
                  <td>{r.envName ?? '—'}{r.tier ? ` (${r.tier})` : ''}</td>
                  <td>{r.operation ?? '—'}</td>
                  <td>{(r.tables ?? []).join(', ')}</td>
                  <td className="dbaudit-sql">{r.sql}</td>
                  <td className={r.allowed ? 'dbaudit-allow' : 'dbaudit-deny'}>
                    {r.allowed ? `✓ ok${r.rowCount != null ? ` (${r.rowCount})` : ''}` : `✕ negado`}
                    {r.reason && <div className="users-muted" style={{ fontSize: 11 }}>{r.reason}</div>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </Page>
  );
}
